export default __webpack_public_path__ + "static/media/plus.4889c338.svg";